import { AuditRoute } from '/@/modules/audit/constants/AuditRoute';
import { RouteConfig } from 'vue-router';

export const router: RouteConfig[] = [
  {
    name: AuditRoute.AUDIT,
    path: `/${AuditRoute.AUDIT}`,
    component: () =>
      import(/* webpackChunkName: "audit-page" */ '/@/modules/audit/pages/AuditPage.vue')
  }
];
